<template>
  <div>
    <!-- Modal para edição de impostos -->
    <b-modal 
      :id="modalId" 
      title="Editar Impostos do Produto" 
      size="lg"
      @ok="salvarImpostos"
      @cancel="cancelarEdicao"
      @hidden="onHidden"
      ok-title="Salvar"
      cancel-title="Cancelar"
    >
      <div v-if="produto">
        <!-- Navegação das Abas -->
        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex">
              <button 
                class="btn btn-outline-primary me-2"
                :class="{ 'active': abaAtiva === 'dados-gerais' }"
                @click="alternarAba('dados-gerais')"
              >
                <i class="bx bx-info-circle"></i> Dados Gerais
              </button>
              <button 
                class="btn btn-outline-primary"
                :class="{ 'active': abaAtiva === 'impostos' }"
                @click="alternarAba('impostos')"
              >
                <i class="bx bx-calculator"></i> Impostos
              </button>
            </div>
          </div>
        </div>

        <!-- Aba Dados Gerais -->
        <b-collapse id="collapse-dados-gerais" v-model="abas.dadosGerais">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="bx bx-info-circle text-primary"></i>
                Dados Gerais
              </h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <div class="alert alert-light">
                    <h6 class="mb-2">{{ produto.dados_xml?.xProd || 'N/A' }}</h6>
                    <div class="row">
                      <div class="col-md-6">
                        <small class="text-muted">
                          <strong>Código Fornecedor:</strong> {{ produto.cod_fornec }}<br>
                          <strong>Fornecedor:</strong> {{ produto.nome_fornecedor }}<br>
                          <strong>Unidade:</strong> {{ produto.unidade_fornecedor || 'N/A' }}
                        </small>
                      </div>
                      <div class="col-md-6">
                        <small class="text-muted">
                          <strong>Código Empresa:</strong> {{ produto.cod_empresa || 'Não definido' }}<br>
                          <strong>Nome Empresa:</strong> {{ produto.nome_empresa || 'Não definido' }}<br>
                          <strong>Fator Conversão:</strong> {{ produto.fator_conv || '1.00' }}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Seção Grupo -->
              <div class="row mb-3">
                <div class="col-md-12">
                  <b-form-group label="Grupo" label-for="grupos">
                    <multiselect
                      id="grupos"
                      v-model="grupoSelecionado"
                      :options="listGrupos"
                      placeholder="Selecione o grupo"
                      track-by="id"
                      deselect-label="Pressione ENTER para remover"
                      label="name"
                      @input="selectGrupo"
                    >
                      <template slot="singleLabel" slot-scope="{ option }">
                        <strong>{{ option.name }}</strong>
                      </template>
                    </multiselect>
                  </b-form-group>
                </div>
              </div>
              
              <div class="row">
                <div class="col-md-6">
                  <b-form-group label="NCM" label-for="ncm">
                    <b-form-input 
                      id="ncm"
                      :value="produto.dados_xml?.ncm || ''"
                      readonly
                      class="form-control-plaintext text-right"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="CFOP" label-for="cfop">
                    <b-form-input 
                      id="cfop"
                      :value="produto.dados_xml?.cfop || ''"
                      readonly
                      class="form-control-plaintext text-right"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
              
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="Quantidade" label-for="qcom">
                    <b-form-input 
                      id="qcom"
                      :value="produto.dados_xml?.qCom || ''"
                      readonly
                      class="form-control-plaintext text-right"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Valor Unitário" label-for="vuncom">
                    <b-form-input 
                      id="vuncom"
                      :value="parseFloat(produto.dados_xml?.vUnCom || '0').toFixed(2)"
                      readonly
                      class="form-control-plaintext text-right"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Valor Total" label-for="vprod">
                    <b-form-input 
                      id="vprod"
                      :value="produto.dados_xml?.vProd || ''"
                      readonly
                      class="form-control-plaintext text-right"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>

        <!-- Aba Impostos -->
        <b-collapse id="collapse-impostos" v-model="abas.impostos">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="bx bx-calculator text-primary"></i>
                Impostos
              </h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <h6 class="text-primary">ICMS</h6>
                  <b-form-group label="Alíquota ICMS (%)" label-for="picms">
                    <b-form-input 
                      id="picms"
                      v-model="dadosEditados.picms"
                      type="number"
                      step="0.01"
                      min="0"
                      max="100"
                      placeholder="0.00"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label="CST/CSOSN" label-for="cst">
                    <multiselect
                      id="cst"
                      v-model="cstSelecionado"
                      :options="listIcmsCST"
                      placeholder="Selecione o CST/CSOSN"
                      track-by="cst"
                      deselect-label="Pressione ENTER para remover"
                      label="descricao"
                      @input="selectCST"
                    >
                      <template slot="singleLabel" slot-scope="{ option }">
                        <strong>{{ option.cst }} - {{ option.descricao }}</strong>
                      </template>
                    </multiselect>
                  </b-form-group>
                  <b-form-group label="Origem" label-for="orig">
                    <b-form-input 
                      id="orig"
                      v-model="dadosEditados.orig"
                      placeholder="0, 1, 2, etc."
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label="Base de Cálculo ICMS (%)" label-for="pbc_icms">
                    <b-form-input 
                      id="pbc_icms"
                      v-model="dadosEditados.pbc_icms"
                      type="number"
                      step="0.01"
                      min="0"
                      max="100"
                      placeholder="100.00"
                    ></b-form-input>
                  </b-form-group>
                </div>
                
                <div class="col-md-6">
                  <h6 class="text-success">PIS</h6>
                  <b-form-group label="CST PIS" label-for="cstpis">
                    <multiselect
                      id="cstpis"
                      v-model="cstPisSelecionado"
                      :options="listPisCST"
                      placeholder="Selecione o CST PIS"
                      track-by="cst"
                      deselect-label="Pressione ENTER para remover"
                      label="descricao"
                      @input="selectCSTPis"
                    >
                      <template slot="singleLabel" slot-scope="{ option }">
                        <strong>{{ option.cst }} - {{ option.descricao }}</strong>
                      </template>
                    </multiselect>
                  </b-form-group>
                  <b-form-group label="Base de Cálculo PIS (%)" label-for="pbc_pis">
                    <b-form-input 
                      id="pbc_pis"
                      v-model="dadosEditados.pbc_pis"
                      type="number"
                      step="0.01"
                      min="0"
                      max="100"
                      placeholder="100.00"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label="Alíquota PIS (%)" label-for="ppis">
                    <b-form-input 
                      id="ppis"
                      v-model="dadosEditados.ppis"
                      type="number"
                      step="0.01"
                      min="0"
                      max="100"
                      placeholder="100.00"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
              
              <div class="row">
                <div class="col-md-6">
                  <h6 class="text-info">COFINS</h6>
                  <b-form-group label="CST COFINS" label-for="cstcofins">
                    <multiselect
                      id="cstcofins"
                      v-model="cstCofinsSelecionado"
                      :options="listCofinsCST"
                      placeholder="Selecione o CST COFINS"
                      track-by="cst"
                      deselect-label="Pressione ENTER para remover"
                      label="descricao"
                      @input="selectCSTCofins"
                    >
                      <template slot="singleLabel" slot-scope="{ option }">
                        <strong>{{ option.cst }} - {{ option.descricao }}</strong>
                      </template>
                    </multiselect>
                  </b-form-group>
                  <b-form-group label="Base de Cálculo COFINS (%)" label-for="pbc_cofins">
                    <b-form-input 
                      id="pbc_cofins"
                      v-model="dadosEditados.pbc_cofins"
                      type="number"
                      step="0.01"
                      min="0"
                      max="100"
                      placeholder="100.00"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label="Alíquota COFINS (%)" label-for="pcofins">
                    <b-form-input 
                      id="pcofins"
                      v-model="dadosEditados.pcofins"
                      type="number"
                      step="0.01"
                      min="0"
                      max="100"
                      placeholder="100.00"
                    ></b-form-input>
                  </b-form-group>
                </div>
                
                <div class="col-md-6">
                  <h6 class="text-warning">IPI</h6>
                  <b-form-group label="CST IPI" label-for="cstipi">
                    <multiselect
                      id="cstipi"
                      v-model="cstIpiSelecionado"
                      :options="listIpiCST"
                      placeholder="Selecione o CST IPI"
                      track-by="cst"
                      deselect-label="Pressione ENTER para remover"
                      label="descricao"
                      @input="selectCSTIpi"
                    >
                      <template slot="singleLabel" slot-scope="{ option }">
                        <strong>{{ option.cst }} - {{ option.descricao }}</strong>
                      </template>
                    </multiselect>
                  </b-form-group>
                  <b-form-group label="Base de Cálculo IPI (%)" label-for="pbc_ipi">
                    <b-form-input 
                      id="pbc_ipi"
                      v-model="dadosEditados.pbc_ipi"
                      type="number"
                      step="0.01"
                      min="0"
                      max="100"
                      placeholder="100.00"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label="Alíquota IPI (%)" label-for="pipi">
                    <b-form-input 
                      id="pipi"
                      v-model="dadosEditados.pipi"
                      type="number"
                      step="0.01"
                      min="0"
                      max="100"
                      placeholder="100.00"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
              
              <div class="row">
                <div class="col-md-6">
                  <h6 class="text-secondary">Outros Campos</h6>
                  <b-form-group label="CEST" label-for="cest">
                    <b-form-input 
                      id="cest"
                      v-model="dadosEditados.cest"
                      placeholder="0"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label="Classificação SPED" label-for="class_sped">
                    <b-form-input 
                      id="class_sped"
                      v-model="dadosEditados.class_sped"
                      placeholder="00"
                    ></b-form-input>
                  </b-form-group>
                </div>
                
                <div class="col-md-6">
                  <h6 class="text-dark">Resumo</h6>
                  <div class="alert alert-info">
                    <small>
                      <strong>ICMS:</strong> {{ dadosEditados.picms }}% | CST: {{ dadosEditados.cst }}<br>
                      <strong>PIS:</strong> {{ dadosEditados.ppis }}% | CST: {{ dadosEditados.cstpis }}<br>
                      <strong>COFINS:</strong> {{ dadosEditados.pcofins }}% | CST: {{ dadosEditados.cstcofins }}<br>
                      <strong>IPI:</strong> {{ dadosEditados.pipi }}% | CST: {{ dadosEditados.cstipi }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: 'EditTax',
  components: {
    Multiselect,
  },
  props: {
    modalId: {
      type: String,
      default: 'modal-edit-tax'
    },
    produto: {
      type: Object,
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    },
    listGrupos: {
      type: Array,
      default: () => []
    },
    configuracaoEmpresa: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      abaAtiva: 'dados-gerais',
      abas: {
        dadosGerais: true,
        impostos: false
      },
      grupoSelecionado: null,
      // Listas para multiselects de CST
      listIcmsCST: [],
      listPisCST: [],
      listCofinsCST: [],
      listIpiCST: [],
      // Seleções de CST
      cstSelecionado: null,
      cstPisSelecionado: null,
      cstCofinsSelecionado: null,
      cstIpiSelecionado: null,
      dadosEditados: {
        picms: "0",
        cst: "00",
        cstpis: "00",
        cstcofins: "00",
        orig: "0",
        cest: "0",
        class_sped: "00",
        cstipi: "00",
        pbc_pis: "100",
        pbc_cofins: "100",
        pbc_icms: "100",
        pbc_ipi: "100",
        pcofins: "100",
        ppis: "100",
        pipi: "100"
      }
    };
  },
  created() {
    // Carrega tabelas de impostos quando o componente é criado
    this.carregarTabelasImpostos();
    console.log('Parece não está passando por aqui')
  },
  watch: {
    produto: {
      handler(newProduto) {
        if (newProduto && newProduto.dados_xml && newProduto.dados_xml.icms) {
          this.carregarDados(newProduto.dados_xml.icms);
        }
        this.definirGrupoPadrao(newProduto);
      },
      immediate: true
    },
    visible(newVisible) {
      if (newVisible) {
        this.$bvModal.show(this.modalId);
      } else {
        this.$bvModal.hide(this.modalId);
      }
    },
    listGrupos: {
      handler(newGrupos) {
        console.log('Grupos recebidos no edit_tax:', newGrupos);
        
        // Se grupos foram carregados e há um produto definido, tenta definir o grupo padrão
        if (newGrupos && newGrupos.length > 0 && this.produto) {
          console.log('Grupos carregados, definindo grupo padrão para produto:', this.produto.cod_fornec);
          this.definirGrupoPadrao(this.produto);
        }
      },
      immediate: true
    }
  },
  methods: {
    alternarAba(aba) {
      this.abaAtiva = aba;
      
      // Controla qual collapse está aberto
      if (aba === 'dados-gerais') {
        this.abas.dadosGerais = true;
        this.abas.impostos = false;
      } else if (aba === 'impostos') {
        this.abas.dadosGerais = false;
        this.abas.impostos = true;
      }
    },

    carregarDados(dadosImpostos) {
      // Carrega os dados atuais para edição
      this.dadosEditados = {
        picms: dadosImpostos.picms || "0",
        cst: dadosImpostos.cst || "00",
        cstpis: dadosImpostos.cstpis || "00",
        cstcofins: dadosImpostos.cstcofins || "00",
        orig: dadosImpostos.orig || "0",
        cest: dadosImpostos.cest || "0",
        class_sped: dadosImpostos.class_sped || "00",
        cstipi: dadosImpostos.cstipi || "00",
        pbc_pis: dadosImpostos.pbc_pis || "100",
        pbc_cofins: dadosImpostos.pbc_cofins || "100",
        pbc_icms: dadosImpostos.pbc_icms || "100",
        pbc_ipi: dadosImpostos.pbc_ipi || "100",
        pcofins: dadosImpostos.pcofins || "100",
        ppis: dadosImpostos.ppis || "100",
        pipi: dadosImpostos.pipi || "100"
      };

      // Define os CSTs selecionados baseados nos dados
      this.definirCSTsSelecionados();
    },

    // Método para definir os CSTs selecionados baseados nos dados
    definirCSTsSelecionados() {
      // ICMS CST
      if (this.dadosEditados.cst && this.listIcmsCST.length > 0) {
        const cstIcms = this.listIcmsCST.find(item => item.cst === this.dadosEditados.cst);
        this.cstSelecionado = cstIcms || null;
      }

      // PIS CST
      if (this.dadosEditados.cstpis && this.listPisCST.length > 0) {
        const cstPis = this.listPisCST.find(item => item.cst === this.dadosEditados.cstpis);
        this.cstPisSelecionado = cstPis || null;
      }

      // COFINS CST
      if (this.dadosEditados.cstcofins && this.listCofinsCST.length > 0) {
        const cstCofins = this.listCofinsCST.find(item => item.cst === this.dadosEditados.cstcofins);
        this.cstCofinsSelecionado = cstCofins || null;
      }

      // IPI CST
      if (this.dadosEditados.cstipi && this.listIpiCST.length > 0) {
        const cstIpi = this.listIpiCST.find(item => item.cst === this.dadosEditados.cstipi);
        this.cstIpiSelecionado = cstIpi || null;
      }
    },

    selectGrupo(value) {
      this.grupoSelecionado = value;
    },

    // Métodos para seleção de CST
    selectCST(value) {
      this.cstSelecionado = value;
      if (value) {
        this.dadosEditados.cst = value.cst;
      }
    },

    selectCSTPis(value) {
      this.cstPisSelecionado = value;
      if (value) {
        this.dadosEditados.cstpis = value.cst;
      }
    },

    selectCSTCofins(value) {
      this.cstCofinsSelecionado = value;
      if (value) {
        this.dadosEditados.cstcofins = value.cst;
      }
    },

    selectCSTIpi(value) {
      this.cstIpiSelecionado = value;
      if (value) {
        this.dadosEditados.cstipi = value.cst;
      }
    },

    // Método para carregar tabelas de impostos
    async carregarTabelasImpostos() {
      try {
        console.log('[edit_tax] Iniciando carregamento de tabelas de impostos...');
        const PedidoManifestoController = (await import('@/controller/PedidoManifestoController')).default;
        const tabelas = await PedidoManifestoController.getTabelasImpostos();
        
        console.log('[edit_tax] Tabelas recebidas do controller:', tabelas);
        
        if (tabelas) {
          this.listIcmsCST = tabelas.icms || [];
          this.listPisCST = tabelas.pis || [];
          this.listCofinsCST = tabelas.cofins || [];
          this.listIpiCST = tabelas.ipi || [];
          
          console.log('[edit_tax] Tabelas de impostos atribuídas aos data properties:', {
            icms: this.listIcmsCST.length,
            pis: this.listPisCST.length,
            cofins: this.listCofinsCST.length,
            ipi: this.listIpiCST.length
          });
          
          // Log de amostra dos dados
          if (this.listIcmsCST.length > 0) {
            console.log('[edit_tax] Exemplo de CST ICMS:', this.listIcmsCST[0]);
          }
          
          // Tenta definir CSTs se já houver dados carregados
          if (this.dadosEditados.cst) {
            this.definirCSTsSelecionados();
          }
        } else {
          console.warn('[edit_tax] Tabelas retornadas estão vazias ou undefined');
        }
      } catch (error) {
        console.error('[edit_tax] Erro ao carregar tabelas de impostos:', error);
        console.error('[edit_tax] Stack trace:', error.stack);
      }
    },

    definirGrupoPadrao(produto) {      
      if (!produto) {
        console.log('Produto não definido, saindo...');
        return;
      }
      
      console.log('Definindo grupo padrão para produto:', produto.cod_fornec);
      console.log('Lista de grupos disponíveis:', this.listGrupos);
      console.log('Grupo_id do produto:', produto.grupo_id);
      
      // Usa o grupo_id que foi definido no processamento do XML
      if (produto && produto.grupo_id && this.listGrupos && this.listGrupos.length > 0) {
        const grupoDefinido = this.listGrupos.find(g => g.id === produto.grupo_id);

        if (grupoDefinido) {
          console.log('Grupo encontrado:', grupoDefinido);
          this.grupoSelecionado = grupoDefinido;
          return;
        } else {
          console.log('Grupo com ID', produto.grupo_id, 'não encontrado na lista de grupos');
          console.log('IDs disponíveis:', this.listGrupos.map(g => g.id));
        }
      } else {
        console.log('Não foi possível definir grupo - grupos não carregados ou produto sem grupo_id');
      }

      this.grupoSelecionado = null;
    },

    salvarImpostos() {
      // Emite evento com os dados editados
      this.$emit('salvar', {
        produto: this.produto,
        dadosImpostos: { ...this.dadosEditados },
        grupoSelecionado: this.grupoSelecionado
      });
      
      this.limparDados();
    },

    cancelarEdicao() {
      this.$emit('cancelar');
      this.$bvModal.hide(this.modalId);
      this.limparDados();
    },

    onHidden(event) {
      this.$emit('hidden', event);
      this.limparDados();
      if (this.visible) {
        this.$emit('cancelar');
      }
    },

    limparDados() {
      // Reset das abas
      this.abaAtiva = 'dados-gerais';
      this.abas.dadosGerais = true;
      this.abas.impostos = false;
      
      // Reset dos dados
      this.grupoSelecionado = null;
      this.cstSelecionado = null;
      this.cstPisSelecionado = null;
      this.cstCofinsSelecionado = null;
      this.cstIpiSelecionado = null;
      this.dadosEditados = {
        picms: "0",
        cst: "00",
        cstpis: "00",
        cstcofins: "00",
        orig: "0",
        cest: "0",
        class_sped: "00",
        cstipi: "00",
        pbc_pis: "100",
        pbc_cofins: "100",
        pbc_icms: "100",
        pbc_ipi: "100",
        pcofins: "100",
        ppis: "100",
        pipi: "100"
      };
    },

    mostrarModal() {
      this.$bvModal.show(this.modalId);
    },

    esconderModal() {
      this.$bvModal.hide(this.modalId);
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
/* Estilos das abas */
.btn-outline-primary.active {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}

.btn-outline-primary {
  border-color: #007bff;
  color: #007bff;
}

.btn-outline-primary:hover {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}

/* Estilos dos cards das abas */
.card {
  border: 1px solid #dee2e6;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

/* Estilos dos headers de seção */
h6 {
  border-bottom: 2px solid;
  padding-bottom: 5px;
  margin-bottom: 15px;
}

.text-primary {
  border-color: #007bff;
}

.text-success {
  border-color: #28a745;
}

.text-info {
  border-color: #17a2b8;
}

.text-warning {
  border-color: #ffc107;
}

.text-secondary {
  border-color: #6c757d;
}

.text-dark {
  border-color: #343a40;
}

/* Estilos dos componentes */
.alert {
  font-size: 0.9rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.form-control-plaintext {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
}

/* Espaçamento */
.me-2 {
  margin-right: 0.5rem;
}
</style>
